import React from 'react';
import styles from "./styles.module.scss";

type DetailProps = {
  title: string;
  color: string;
  value: string;
};

interface ChartLegendProps {
  data: Array<DetailProps>;
}

const ChartLegend = ({ data = [] }: ChartLegendProps) => {
  return (
    <div className={styles.chart_legend}>
      {data.map((d) => (
        <div className={styles.legend_row} key={`${d.value}${d.color}`}>
          <div className={styles.left}>
            <div
              className={styles.legend_bullet}
              style={{
                backgroundColor: d.color,
              }}
            />
            <span className={styles.legend_title}>{d.title}</span>
          </div>
          <div className={styles.right}>{d.value}</div>
        </div>
      ))}
    </div>
  );
};

export default ChartLegend;
